import { Selector, State } from "./types";
import { match } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveConstraintRequestFailure(constraint) {
      const req = getState().find((req) => match(req.constraint, constraint));

      return req ? req.request.isFailure : false;
    },
    isRemoveConstraintRequestPending(constraint) {
      const req = getState().find((req) => match(req.constraint, constraint));

      return req ? req.request.isPending : false;
    },
    isRemoveConstraintRequestSuccess(constraint) {
      const req = getState().find((req) => match(req.constraint, constraint));

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
